
import {post} from '@/utils/request';
import {smcanteenserver} from '@/utils/baseUrl';

//菜品下拉
export async function getFoodList(params) {
    return post(smcanteenserver+'/foodInfo/getFoodList', params, true)
}

//食堂下拉
export async function getCanteenList(params) {
    return post(smcanteenserver+'/canteen/getCanteenList', params, true)
}

//餐别下拉
export async function getDataDict(params) {
    return post(smcanteenserver+'/foodInfo/getDataDict', params, true)
}

//菜谱保存
export async function save(params) {
    return post(smcanteenserver+'/cookbook/save', params, true)
}

//菜谱列表
export async function getList(params) {
    return post(smcanteenserver+'/cookbook/getList', params, true)
}

//菜谱删除
export async function remove(params) {
    return post(smcanteenserver+'/cookbook/delete', params, true)
}

//菜谱确认发布
export async function release(params) {
    return post(smcanteenserver+'/cookbook/release', params, true)
}

//菜谱详情
export async function getDetail(params) {
    return post(smcanteenserver+'/cookbook/getDetail', params, true)
}